import { getReportEvent } from './utils';
const report = ({ isCodePage }) => {
    const eventKey = getReportEvent('uicore');
    if (eventKey) {
        const event = new CustomEvent(eventKey, { detail: { isCodePage } });
        document.dispatchEvent(event);
    }
};
export default report;
